import {NgModule, ModuleWithProviders} from '@angular/core';

import {FishPopover, FishPopoverWindow} from './popover';
import {FishPopoverConfig} from './popover-config';

export {FishPopover} from './popover';
export {FishPopoverConfig} from './popover-config';


export class FishPopoverModule {
  static forRoot(): ModuleWithProviders { return {ngModule: FishPopoverModule, providers: [FishPopoverConfig]}; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [FishPopover, FishPopoverWindow], 
  exports: [FishPopover], 
  entryComponents: [FishPopoverWindow]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
